import { FloatingLabel, Form, InputGroup } from 'react-bootstrap';

/**
 * FormField component
 * @param {Object} obj - Objeto de props
 * @param {string} obj.val - valor do campo
 * @param {function} obj.onValueUpdate - callback chamada quando o valor do campo mudar
 * @param {function} obj.onBlur - callback chamada quando o campo perder o foco
 * @param {string} obj.label - label do campo
 * @param {string} obj.ty - tipo do campo
 * @param {function} obj.actionClick - callback chamada quando o bot o  de a o for clicado
 * @param {function} obj.actionClick2 - callback chamada quando o segundo bot o  de a o for clicado
 * @param {object} obj.reference - refer ncia para o campo
 * @param {object} obj.others - outros props para o campo
 * @param {object} obj.styleObj - estilo do campo
 * @param {boolean} obj.locked - se o campo est  bloqueado
 * @param {boolean} obj.hide - se o campo deve ser escondido
 * @param {function} obj.onMouseLv - callback chamada quando o mouse sair do campo
 * @param {function} obj.onEnterPress - callback chamada quando a tecla Enter for pressionada
 * @param {string} obj.className - classe CSS do campo
 * @param {boolean} obj.isInvalid - se o campo   inv lido
 * @param {string} obj.feedback - mensagem de feedback do campo
 * @param {function} obj.onFocus - callback chamada quando o campo ganhar o foco
 * @param {number} obj.rows - n mero de linhas do campo, se for um textarea
 * @param {boolean} obj.asTextArea - se o campo deve ser um textarea
	*/
const FormField = ({
	val,
	onValueUpdate,
	onBlur,
	label,
	ty,
	actionClick,
	actionClick2,
	reference,
	others,
	styleObj,
	locked,
	hide,
	onMouseLv,
	onEnterPress,
	className,
	isInvalid,
	feedback,
	onFocus,
	rows,
	asTextArea,
	controlId

}) => {
	const onKeyDownHandler = (event) => {
		if (event.code == 'Enter') {
			onEnterPress && onEnterPress(event.target.value);
		}
	};
	const onFocusHandler = (value) => {
		onFocus && onFocus(value)
	}

	const rendeField = () => {
		if(asTextArea) others = {...others , as : "textarea"}
		return <Form.Control
			autoComplete='off'
			isInvalid={isInvalid}
			className={className}
			{...others}
			required={others?.required}
			onBlur={(event) => onBlur && onBlur(event.target.value, event)}
			disabled={locked}
			style={styleObj}
			ref={reference}
			placeholder={others?.placeholder || label}
			type={ty || 'text'}
			value={val}
			onChange={(event) =>
				onValueUpdate && onValueUpdate(event.target.value, event)
			}></Form.Control>
	}
	return (
		<>
			<Form.Group
				onFocusCapture={(e) => onFocusHandler(e.target.value)}

				onMouseLeave={onMouseLv}
				onKeyDown={onKeyDownHandler}
				style={{ marginTop: 4, marginBottom: 4, width: "100%", display: hide ? 'none' : '' }}>
				<InputGroup>
					{asTextArea ? rendeField() : <FloatingLabel style={{ zIndex: 0 }} label={label} controlId={controlId || 'floatingInput'}>
						{rendeField()}
					</FloatingLabel> }
					{actionClick && actionClick()}
					{actionClick2 && actionClick2()}
				</InputGroup>
				{feedback && <Form.Control.Feedback type="invalid">
					{feedback}
				</Form.Control.Feedback>}
			</Form.Group>
		</>
	);
};

export default FormField;
